import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import HoldingStatusSelectBox from 'components/molecules/holding-status-select-box';

import s from './styles.module.scss';

interface IProps {
  value?: string[];
  onChange: (e?: string[]) => void;
}

const HoldingFilter: FC<IProps> = ({ onChange, value }) => {
  const { t } = useTranslation();
  const label = `${t('labels.exclude')} ${t('labels.holdingStatus')}`;

  return (
    <div className={s['available-billable-minutes-wrapper']}>
      <label data-cy="holding-status-filter">{label}</label>
      <HoldingStatusSelectBox
        mode="multiple"
        placeholder={t('labels.all')}
        showSelectAll
        value={value}
        onChange={onChange}
        allowClear
      />
    </div>
  );
};

export default HoldingFilter;
